import { render, staticRenderFns } from "./my-profile.component.vue?vue&type=template&id=7af2858d&scoped=true"
import script from "./my-profile.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./my-profile.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./my-profile.component.vue?vue&type=style&index=0&id=7af2858d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2858d",
  null
  
)

export default component.exports